export default __webpack_public_path__ + "static/media/infra.fae9f43d.png";